import styled from 'styled-components';

import { Multiselect } from '@dreryk/react-components';

export const StyledDayPreferenceFieldMultiselect = styled(Multiselect)`
   width: 280px;
` as typeof Multiselect;
